import React from 'react';
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from '@mui/material/useMediaQuery'
import { useStyles } from "../styles/styles";
import { getDecimal } from "../global/utils";
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from "@mui/material/Button";
import Tooltip from '@mui/material/Tooltip';
import InstallmentList from "./InstallmentList";
import Zoom from "@mui/material/Zoom";

const PlanList = (props) => {
    const plans = props.plans;
    const selectPlan = props.selectPlan;
    const listTitle = props.listTitle;
    const theme = useTheme();
    const tiny = useMediaQuery(theme.breakpoints.down('sm'));
    const classes = useStyles;

    return (
        <>
            <Typography variant='h6' component='h2' color='primary' sx={{...classes.title, fontSize: '1.2rem', marginTop: '0.2rem', marginBottom: '.5rem'}}>{listTitle ? listTitle : 'Payment Plans'}</Typography>
            <Paper elevation={3} sx={{...classes.listContainer, maxHeight: '65vh', overflow: 'auto'}}>
                <List sx={classes.list} >
                    {plans && plans.length > 0 && plans.map((plan) => {
                        return ( !plan.selected ?
                                <>
                                    <ListItem alignItems='flex-start' sx={classes.listPadding}>
                                        <ListItemText
                                            sx={classes.listText}
                                            primary={
                                                <Grid
                                                    container
                                                    spacing={2}
                                                    alignItems="top"
                                                    style={{width: '100%'}}
                                                >
                                                    <Grid item xs={3} lg={2}>
                                                        <Tooltip title='Add plan to the payment list' TransitionComponent={Zoom} arrow>
                                                            { tiny ?
                                                                <Button color="success" onClick={() => selectPlan(plan)} sx={{padding: '0'}}>
                                                                    Add to Cart
                                                                </Button> :
                                                                <Button variant='contained' color='success' onClick={() => selectPlan(plan)} sx={{...classes.tinyButton, fontSize: {xs: '.65rem', md: '.7rem'}, whiteSpace: 'nowrap', padding: '0 .3rem'}} >
                                                                    Add to Cart
                                                                </Button>
                                                            }
                                                        </Tooltip>
                                                    </Grid>
                                                    <Grid item xs={9} lg={5} >
                                                        {plan.planDescription}
                                                    </Grid>
                                                    <Grid item xs={12} lg={5}>
                                                        <Typography component='span' variant='subtitle2' color='secondary' >
                                                            Select one or more installments to pay
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            }
                                            primaryTypographyProps={{
                                                component: 'span',
                                                variant: 'subtitle2',
                                                sx: classes.inline,
                                                color: 'textPrimary'
                                            }}
                                            secondary={ plan.installments &&
                                                <>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        alignItems="top"
                                                    >
                                                        <Grid item xs={12}>
                                                            <InstallmentList installments={plan.installments} />
                                                        </Grid>
                                                    </Grid>
                                                    { plan.planPaymentServiceFee && plan.planPaymentServiceFee > 0 &&
                                                        <Grid item xs={12} style={{paddingTop: '0'}}>
                                                            <Typography color='secondary'>
                                                                A payment plan service fee of ${getDecimal(plan.planPaymentServiceFee)} will be added.
                                                            </Typography>
                                                        </Grid>
                                                    }
                                                </>
                                            }
                                            secondaryTypographyProps={{
                                                component: 'span',
                                                variant: 'body2',
                                                sx: classes.inline,
                                                color: 'textPrimary'
                                            }}
                                        />
                                    </ListItem>
                                    <Divider/>
                                </> : null
                        );
                    })}
                </List>
            </Paper>
        </>
    );
}

export default PlanList;